import { render, staticRenderFns } from "./UpdateThreshold.vue?vue&type=template&id=69a66654&"
import script from "./UpdateThreshold.vue?vue&type=script&lang=ts&"
export * from "./UpdateThreshold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports